<template>
  <div class="">
<!--body content start-->

<div id="main-page" class="page-content">

<!--coming soon start-->

<section class="fullscreen-banner p-0">
  <div class="hero-animation"> <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
    <div class="hero-text"> <span>A</span>
    <span>G</span>
    <span>E</span>
    <span>N</span>
    <span>C</span>
    <span>I</span>
    <span>O</span>
  </div>
  <div class="container-fluid px-lg-5 h-100">
    <div class="row h-100 align-items-center justify-content-between">
      <div class="col-lg-5 col-md-12">
        <img class="img-fluid" src="images/coming-soon.png" alt="">
      </div>
      <div class="col-lg-6 col-md-12">
        <h1 class="mb-2">Coming Soon</h1> 
          <p>We Are Creatinig Something Awesome And Exciting For You</p>
        <div class="coming-soon w-100">
          <ul class="countdown list-inline d-flex align-items-center" data-countdown="2020/08/08"></ul>
          <div>
            <h4 class="title z-index-1 mb-4">Subscribe to get notified!</h4>
            <div class="subscribe-form w-50">
              <form id="mc-form" class="group">
                <input type="email" value="" name="EMAIL" class="email" id="mc-email" placeholder="Enter Email Address" required="">
                <input class="btn" type="submit" name="subscribe" value="Subscribe">
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--coming soon end-->

</div>

<!--body content end--> 
  </div>
</template>

<script>


export default {
    data: function () {
        return {
            name: 'Comming Soon',
        }
    },
};
</script>
